import React from "react"
import CTAButton from "src/components/common/CTAButton"
import { StyledSplitSection } from "src/components/common/StyledSplitSection"
import styled from "styled-components"

const GetYourAdSection = () => {
  return (
    <StyledGetYourAdSection>
      <div className="content-side">
        <div className="content">
          <h2>
            Get Your Ad <br />
            on Fubo Sports Network
          </h2>
          <p>
            Our viewers are passionate sports fans. Got an ad you think they’ll
            love? Get in touch.
          </p>
          <CTAButton link="https://www.disneyadvertising.com/contact/">Contact Ad Sales</CTAButton>
        </div>
      </div>
      <div className="image-side">
        <div className="image-container">
          <div className="image">
            <img
              src="https://assets-imgx.fubo.tv/marketing/lp/images/fsn/contact/ads-on-fubo-sports.jpg?ch=width&auto=format,compress"
              alt=""
            />
          </div>
        </div>
      </div>
    </StyledGetYourAdSection>
  )
}

export default GetYourAdSection

const StyledGetYourAdSection = styled(StyledSplitSection)`
  background: linear-gradient(180deg, #2c2f3d 2.19%, #161822 98.44%);
  @media (max-width: 767px) {
    flex-direction: column;
    .image-side {
      align-self: flex-end;
    }
  }
  .content-side {
  }
  .image-side {
    .image-container {
      border-right: none;
      border-radius: 300px 0 0 300px;
      padding: 10px 0 10px 10px;
      .image {
        border-radius: 300px 0 0 300px;
      }
    }
  }
`
